import classes from "./CardsHorizontal.module.scss"
import Cards from './../../../../Cards/Cards';

const CardsHorizontal = (props) => {
   return (
    <div className={classes.CardsHorizontal }>
    <div className={classes.Item + "   " + props.customHorizontalClass || ""}>
      <Cards
        number={props.num}
        title={props.title}
        customClass={classes.Cards}
        customTitleClass={classes.CardsTitle}
        customClassText={classes.CustomText}
      />
      <div className={classes.RightSide + " " + props.CustomDescription || ""}>
        <p className={classes.Text}>{props.text}</p>
        <p className={classes.Text}>{props.textSecond}</p>
      </div>
    </div>
   </div>
   )
}

export default CardsHorizontal;